import { z } from "zod";

import { companyFormSchema } from "./components/company-form/company-form.component";

export type CompanyFormData = z.infer<typeof companyFormSchema>;

export interface CompletionStatus {
  sms_completed: boolean;
  company_form_completed: boolean;
}

export enum Pages {
  SMS_FORM = "sms_form",
  COMPANY_FORM = "company_form",
  CONFIRMATION = "confirmation",
}
